<script lang="ts" setup>
import { clearError, type NuxtError } from '#app'
import { getMetaTags } from '~/utils/meta'
import { rootSvgImages } from '~/models/images'

interface ErrorPageProps {
  error: NuxtError
}

const props = defineProps<ErrorPageProps>()

const { t, baseKey } = useI18n('pages.error')

useSeoMeta(
  getMetaTags(
    {
      title: '.meta.title',
      description: '.meta.description'
    },
    undefined,
    baseKey
  )
)

const onNavigate = () => {
  clearError()
}
</script>

<template>
  <div>
    <NuxtLayout name="no-hero" hide-spacer>
      <UError :error="{ statusMessage: t('.title') }" as="div">
        <template #statusCode>
          <div class="mb-4 flex flex-col items-center">
            <VImage
              :image="rootSvgImages['thuisgekookt-succes']"
              :dark="rootSvgImages['thuisgekookt-succes-dark']"
              use-img
              class="mb-2"
            />
            <h2 class="section-title text-h2 font-bold">{{ error.status }}</h2>
          </div>
        </template>

        <template #message>
          <div class="mx-auto max-w-lg text-center">
            <VI18n key-path=".description">
              <template #faq>
                <VLink
                  :to="{ name: 'vragen' }"
                  label=".frequently-asked-questions"
                  @click="onNavigate"
                />
              </template>
            </VI18n>

            <ul
              v-if="error.status !== 404 && error.status !== 410"
              class="mt-5 list-none text-sm text-warning opacity-80"
            >
              <li>{{ t('.dev.message') }} {{ error.message }}</li>
              <li>
                {{ t('.dev.status-message') }}
                {{ error.statusText ?? '-' }}
              </li>
              <li>
                {{ t('.dev.description') }}
                {{ error.data ?? '-' }}
              </li>
              <li>{{ t('.dev.code') }} {{ error.status }}</li>
            </ul>
          </div>
        </template>

        <template #links>
          <div class="mt-4 flex justify-center">
            <VButton :to="{ name: 'index' }" label=".button" @click="onNavigate" />
          </div>
        </template>
      </UError>
    </NuxtLayout>
  </div>
</template>

<style scoped></style>
